import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../layout/header/Header";
import "./accessManagement.scss";
import { db } from "../../../database";
import Loading from "../../layout/loader/Loading";
import { toast } from "react-toastify";
import axiosInstance from "../../../httpInterceptor";
import EmployeeTable from "../employees-list/EmployeesList";
import { Employee } from "../employees-list/EmployeesList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import bg2 from "../../../images/bg2.png"
import { Box } from "@mui/material";
const AccessManagement = () => {
  const [input, setInput] = useState("");
  const [flag, setFlag] = useState(true);
  const [selectedList, setSelectedDetails] = useState({
    psno: "",
    email: "",
    firstName: "", // first name
    lastName: "", // last name
  });
  const [showDetails, setShowDetails] = useState(false);
  const [currRole, setCurrRole] = useState<any>("No Role");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEmployeeTable, setShowEmployeeTable] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
 
  const [updateRole, setUpdateRole] = useState({
    psNo: "",
    role: "",
  });
  const [psNo, setPsNo] = useState("");
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [updatedEmployee, setUpdatedEmployee] = useState<Employee | null>(null);
 
  const getRole = async (PsNo: any) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_USER_SERVICE_BASE_URL}/getUserRole/?PsNo=${PsNo}`
      );
      if (res) {
        setCurrRole(res.data);
      }
    } catch (error) {
      if (error) {
        console.log("Error fetching the data", error);
      }
    }
  };
  useEffect(() => {
    if (psNo.length > 0) getRole(psNo);
  }, [psNo]);
 
  useEffect(() => {
    if (currRole && currRole !== "No Role") {
      setUpdateRole({ ...updateRole, role: currRole });
    }
  }, [currRole]);
 
  useEffect(() => {
    setIsSaveDisabled(updateRole.role === "" || updateRole.role === currRole);
  }, [updateRole, currRole]);
 
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
 
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
 
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);
 
  const fetchSuggestions = async (search: string) => {
    if (!search) return;
 
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_USER_SERVICE_BASE_URL}/getPSNumber/?search=${search}`
      );
      setSuggestions(response.data);
      console.log("Suggestion list",response.data) // Adjust according to your API response structure
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };
 
  const handleChange = (value: string) => {
    setInput(value);
    setFlag(true);
    setSuggestions([]);
    setShowDetails(false);
    setCurrRole("No Role");
    setUpdateRole({ psNo: "", role: "" });
    fetchSuggestions(value);
    if (value == "") {
      setFlag(false);
    }
  };
 
  const handleUpdateRole = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setUpdateRole({ ...updateRole, [name]: value, psNo: psNo });
  };
  const handleOnClick = (value: any) => {
    setFlag(true);
    setSelectedDetails(value);
    setPsNo(value.psno);
    setShowDetails(true);
    setInput("");
    setSuggestions([]);
    setLoading(false);
    setShowEmployeeTable(false);
  };
 
  // export default AccessManagement;
  const handleSaveRole = async () => {
    const fullName = `${selectedList.firstName} ${selectedList.lastName}`;
    try {
      const NewRole = {
        name: fullName,
        email: selectedList.email,
        psNo: psNo,
        role: updateRole.role,
      };
      const SaveRole = await axiosInstance.post(
        `${process.env.REACT_APP_USER_SERVICE_BASE_URL}/updateUserRole`,
        NewRole
      );
      setCurrRole(SaveRole.data.role);
      
      // Update the employee in the table without refetching
      setUpdatedEmployee({
        id: 0, // Not needed for update
        name: fullName,
        email: selectedList.email,
        psNo: psNo,
        role: updateRole.role,
        timeStamp: new Date().toISOString()
      });
      
      toast.success("Role Updated successfully");
      // Navigate to EmployeeTable i use set true
      setShowEmployeeTable(true);
      setShowDetails(false);
      setInput("");
      setSuggestions([]);
    } catch (error) {
      console.log("Error saving the role", error);
    }
  };
  console.log(selectedList);
  const handleRowClick = (employee: Employee) => {
    const nameParts = employee.name.split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(" ");
    setSelectedDetails({
      psno: employee.psNo,
      email: employee.email,
      firstName: firstName,
      lastName: lastName,
    });
    setPsNo(employee.psNo);
    setShowDetails(true);
    setShowEmployeeTable(false);
    getRole(employee.psNo);
  };
  const cancelRole = async () => {
    setShowEmployeeTable(true);
    setShowDetails(false);
    setInput("");
    setSuggestions([]);
  };
  return (
    <div className="accessManagementContainer">
      <Navbar />
      <div className="app-pageSize">
        <div className="app-pageHeader searchHeader">
          <div className="searchBarWrapper">
            <input
              className="searchBar"
              type="text"
              placeholder="Search employees with Name, PS-id to whom want to assign any role..."
              autoCapitalize="words"
              value={input}
              onChange={(e) => handleChange(e.target.value)}
            />
            {input && (
              <FontAwesomeIcon 
                icon={faXmark} 
                className="clearSearchBtn"
                onClick={() => {
                  setInput("");
                  setSuggestions([]);
                  setShowDetails(false);
                  setCurrRole("No Role");
                  setUpdateRole({ psNo: "", role: "" });
                }}
              />
            )}
            {!input && (
              <FontAwesomeIcon icon={faMagnifyingGlass} className="searchIcon"/>
            )}
          </div>
        </div>
        {flag && (
          <div className={suggestions.length > 0 ? "showResult" : ""}>
            {suggestions.length > 0 &&
              suggestions.map(
                (result: { name: string; jobtitle: string }, idx) => {
                  return (
                    <div
                      key={idx}
                      style={{
                        display: "grid",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOnClick(result)}
                    >
                      <span> {result.name}</span>
                      <span> {result.jobtitle}</span> <br />
                    </div>
                  );
                }
              )}
          </div>
        )}
        {showEmployeeTable && <EmployeeTable onRowClick={handleRowClick} updatedEmployee={updatedEmployee} />}
        {showDetails && (
          <div className="userDetailsContainer">
            <div className="userdetailHeader">
              <div className="avatar-circle">
                <span>{selectedList.firstName.charAt(0)}{selectedList.lastName.charAt(0)}</span>
              </div>
              <span className="header-title">User Details</span>
              <span className="header-subtitle">Review user information and update role access</span>
            </div>
            <div className="userDetails">
              <div className="details-grid">
                <div className="detail-row">
                  <div className="detail-item">
                    <label>FIRST NAME</label>
                    <span className="detail-value">{selectedList.firstName}</span>
                  </div>
                  <div className="detail-item">
                    <label>LAST NAME</label>
                    <span className="detail-value">{selectedList.lastName}</span>
                  </div>
                </div>
                <div className="detail-row">
                  <div className="detail-item">
                    <label>EMAIL</label>
                    <span className="detail-value">{selectedList.email}</span>
                  </div>
                  <div className="detail-item">
                    <label>PS NO</label>
                    <span className="detail-value">{selectedList.psno}</span>
                  </div>
                </div>
                <div className="detail-row">
                  <div className="detail-item">
                    <label>CURRENT ROLE</label>
                    <div className="current-role-badge">
                      <span className="role-dot">●</span>
                      <span className="role-text">{currRole}</span>
                    </div>
                  </div>
                  <div className="detail-item">
                    <label>UPDATE ROLE</label>
                    <div className="custom-select-wrapper" ref={dropdownRef}>
                      <div
                        className="custom-select"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        <span className={updateRole.role === "" ? "placeholder" : ""}>
                          {updateRole.role === "" ? "Select a role" : updateRole.role}
                        </span>
                        <span className="dropdown-arrow">▼</span>
                      </div>
                      {isDropdownOpen && (
                        <div className="custom-options">
                          {db.role &&
                            db.role.map((res) => (
                              <div
                                key={res}
                                className={`custom-option ${res === currRole ? 'disabled' : ''} ${updateRole.role === res ? 'selected' : ''}`}
                                onClick={() => {
                                  if (res !== currRole) {
                                    setUpdateRole({ ...updateRole, role: res, psNo: psNo });
                                    setIsDropdownOpen(false);
                                  }
                                }}
                              >
                                {res}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
 
              <div className="button-container">
                <button
                  className="saveButton"
                  type="button"
                  disabled={isSaveDisabled}
                  onClick={handleSaveRole}
                >
                  Save
                </button>
                <button
                  className="cancelButton"
                  type="button"
                  onClick={cancelRole}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
 
export default AccessManagement;
 
 